const buildListJobsQuickFilters = (defaultDepartmentId = null) => {
  const selectedDepartments = defaultDepartmentId ? [{ departmentId: defaultDepartmentId }] : [];

  return [
    {
      name: 'department',
      searchKey: 'department.id',
      data: [],
      selected: selectedDepartments,
      placeholder: 'Department',
      idKey: 'departmentId',
      labelKey: 'departmentName'
    },
    {
      name: 'status',
      searchKey: 'status.keyword',
      data: [{ status: 'active' }, { status: 'archived' }],
      selected: [],
      placeholder: 'Status',
      idKey: 'status',
      labelKey: 'status'
    },
    {
      name: 'owner',
      searchKey: 'owner.id',
      data: [],
      selected: [],
      placeholder: 'Project Owners',
      idKey: 'userId',
      labelKey: 'ownerFirstName'
    }
  ];
};

export default buildListJobsQuickFilters;
